import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Scheduling/hooks/useShiftDetail.ts
function useShiftDetail(id, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : !!id;
	const { call, data, isCalling } = useRPC(RPCs.Scheduling.GetShiftDetail.v1, id ? { shiftId: id } : void 0, {
		cacheStrategy: opts.cacheStrategy,
		fire
	});
	return {
		data: data?.shift,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useShiftDetail };

//# sourceMappingURL=useShiftDetail.js.map